// PermissionRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import { getPermissionLevel, isSuperadmin } from '../utils/permissions';

export default function PermissionRoute({ children, menuId, requiredLevel = 1 }) {
  const permLevel = getPermissionLevel(menuId);
  const hasPerm = isSuperadmin() || permLevel >= requiredLevel;

  if (!hasPerm) {
    return <Navigate to="/401" replace />;
  }

  return <PrivateRoute>{children}</PrivateRoute>;
}
